import { z } from 'zod';

/**
 * Resolução por-card (Fase 2) — estado server-authoritative de um componente
 * interativo de UI (`voucher_cancellation`, `product_checkout`). O
 * `interactionId` é o identificador unificado da interação; nos cards
 * destrutivos é o PRÓPRIO `challengeId` (single-use, verificado server-side).
 *
 * Quando o cliente aciona o card (clica em confirmar), o servidor registra a
 * resolução por-conversa de forma idempotente (por interactionId). Na recarga
 * (`/history`) o mapa é projetado junto das mensagens — o card resolvido
 * renderiza somente-leitura SEM depender de estado do cliente. Congela um card
 * específico no meio de uma conversa ativa, independentemente da posição.
 */
export const UiResolutionStatusSchema = z.enum(['pending', 'resolved', 'expired', 'cancelled']);
export type UiResolutionStatus = z.infer<typeof UiResolutionStatusSchema>;

export const UiResolutionSchema = z
  .object({
    interactionId: z.string().min(1),
    status: UiResolutionStatusSchema,
    /** Instante ISO 8601 da resolução; ausente enquanto `pending`. */
    resolvedAt: z.iso.datetime().optional(),
  })
  .strict();
export type UiResolution = z.infer<typeof UiResolutionSchema>;

/** Lista de resoluções projetada na sessão/histórico (wire shape estável). */
export const UiResolutionListSchema = z.array(UiResolutionSchema);
